import { render, staticRenderFns } from "./PostDetailPage.vue?vue&type=template&id=1ae7b0f0&scoped=true"
import script from "./PostDetailPage.vue?vue&type=script&lang=js"
export * from "./PostDetailPage.vue?vue&type=script&lang=js"
import style0 from "./PostDetailPage.vue?vue&type=style&index=0&id=1ae7b0f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae7b0f0",
  null
  
)

export default component.exports